<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import ProcedureForm from './ProcedureForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { Company } from '@/types';
    import { Button } from '@/components/ui/button';
    import { DialogFooter, DialogClose } from '@/components/ui/dialog';
    import { useI18n } from 'vue-i18n';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';

    const props = defineProps<{
        company: Company;
    }>();

    const { t } = useI18n();
    const { hasPermission } = usePermissions();

    const form = useForm({
        company_id: props.company.id,
        procedure_task: '',
        procedure_responsible: [],
        procedure_deadline: '',
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.dashboard.procedures.create')"
        :query-key="[QueryKey.DASHBOARD_PROCEDURES, props.company.id]"
        title="dashboards.procedures_create"
        button-text="dashboards.procedures_create"
    >
        <ProcedureForm :form="form" />

        <template #footer>
            <DialogFooter class="gap-2 border-t sm:justify-center">
                <DialogClose as-child>
                    <Button
                        variant="outline"
                        size="sm"
                        @click="form.resetAndClearErrors()"
                    >
                        {{ $t('forms.cancel') }}
                    </Button>
                </DialogClose>

                <Button
                    v-if="hasPermission(Permission.DASHBOARD_ADMIN_CREATE)"
                    :disabled="form.processing"
                    :loading="form.processing"
                    size="sm"
                    variant="default"
                >
                    {{ t('dashboards.procedures_create') }}
                </Button>
            </DialogFooter>
        </template>
    </DialogForm>
</template>
